import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BidListStateService {
  private _isSharedList: boolean;
  private _hasRemovableBidListItem = false;
  constructor() {}

  set hasRemovableBidListItem(value: boolean) {
    this._hasRemovableBidListItem = value;
  }

  get hasRemovableBidListItem() {
    return this._hasRemovableBidListItem;
  }

  set isSharedList(value: boolean) {
    this._isSharedList = value;
  }

  get isSharedList() {
    return this._isSharedList;
  }
}
